export default __webpack_public_path__ + "static/media/blog_inner_14.268aaf72.png";